import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getTransactionList = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');
    return this.get(
      `/settlements/billingInquiries?page=${page}&limit=10${
        Boolean(state) ? '&filterBy=billingStatus:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`
    );
  };

  public getTransactionDetail = (id: NumberConstructor) => {
    return this.get(`/settlements/billingInquiries/${id}`);
  };

  public getLogisticsCenterList = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');
    return this.get(
      `/settlements/serviceInquiries?page=${page}&limit=10${
        Boolean(state) ? '&filterBy=serviceStatus:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };

  public getLogisticsCenterDetail = (id: NumberConstructor) => {
    return this.get(`/settlements/serviceInquiries/${id}`);
  };

  public exportTransactionExcell = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');

    return this.post(
      `/settlements/billingInquiries/export?page=${page}&${
        Boolean(state) ? '&filterBy=billingStatus:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportTransactionExcellById = (listId: any) => {
    return this.post(
      `/settlements/billingInquiries/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public exportLogisticsCenterExcell = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    filter?: string,
    input?: string,
    sort?: boolean
  ) => {
    const inputEncode = input?.replaceAll('%', '%25').replaceAll('#', '%23');

    return this.post(
      `/settlements/serviceInquiries/export?page=${page}&${
        Boolean(state) ? '&filterBy=serviceStatus:' + state : '&filterBy='
      }${Boolean(input) ? '&search=' + inputEncode : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(filter) ? '&searchBy=' + filter : '&searchBy='
      }${
        Boolean(!sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public exportLogisticsCenterExcellById = (listId: any) => {
    return this.post(
      `/settlements/serviceInquiries/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public createInquiryService = (id: number, serviceAmount: number) => {
    return this.post(`/settlements/serviceInquiries/${id}`, { serviceAmount });
  };

  public getForwardingList = async (
    page: number,
    search?: string,
    filterInput?: string,
    fromDt?: string,
    toDt?: string
  ) => {
    const filterInputEncode = filterInput
      ?.replaceAll('%', '%25')
      .replaceAll('#', '%23');
    return this.get(
      `/forwardings?page=${page}&limit=10${
        Boolean(search) ? '&searchBy=' + search : ''
      }${Boolean(filterInput) ? '&search=' + filterInputEncode : ''}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : ''
      }${Boolean(toDt) ? '&toDt=' + toDt : ''}`
    );
  };
}

export default new buskService('/api/v1/admin', true);
